<template>
  <div>
    <v-dialog v-model="sespend" persistent max-width="1200">
      <v-card outlined>
        <v-card-title class="primary white--text">
          <div class="flex justify-between">
            <span>
              {{
              isView ? "" : event == "edit" ? $t('account.edit_data') : $t('account.create_form')
              }}{{ $t('suspend.suspend_sale') }}
            </span>
            <v-btn color="white" icon @click="sespend = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="overflow-y-auto dialog-suspend-form-in">
          <v-row>
            <v-col cols="6" class="pb-0">
              <h3 class="my-2 mt-5 font-normal">{{ $t('suspend.type_suspend_sale') }}</h3>
              <v-radio-group v-model="form.type" column :readonly="isView" class="mt-0">
                <v-radio
                  v-for="suspendType of suspendTypeLabel"
                  :key="suspendType.value"
                  :label="suspendType.label"
                  :value="suspendType.value"
                  :disabled="isView"
                ></v-radio>
                <v-text-field
                  class="mx-8"
                  v-if="form.type == 'other'"
                  :rules="[rules.required]"
                  :disabled="isView"
                  :label="$t('suspend.input_title_business_suspend')"
                  outlined
                  dense
                  rounded
                  background-color="grey lighten-4"
                  v-model="form.otherType"
                ></v-text-field>
              </v-radio-group>
            </v-col>
            <v-col cols="6" class="pb-0">
              <h3 class="my-2 mt-5 font-normal">{{ $t('suspend.suspend_and_sale_stall') }}</h3>
              <v-row>
                <v-checkbox
                  :label="$t('suspend.suspend_stall')"
                  v-model="form.isSuspend"
                  :disabled="isView || event == 'edit'"
                ></v-checkbox>
              </v-row>
              <v-row v-if="form.isSuspend">
                <v-col cols="12" class="pb-0">
                  <h3 class="mb-2 font-normal">{{ $t('suspend.suspend_stall_time') }}</h3>
                </v-col>
                <v-col cols="4" class="pt-0">
                  <v-menu
                    ref="startDate"
                    v-model="startDatePicker"
                    :close-on-content-click="false"
                    :return-value.sync="startDate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    :disabled="isView"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="isView"
                        v-model="startDate"
                        :label="$t('start_date')"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        solo
                        flat
                        v-bind="attrs"
                        rounded
                        background-color="grey lighten-4"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="th"
                      v-model="startDate"
                      no-title
                      :header-date-format="$helper.headerDateFormat"
                      :year-format="$helper.yearFormat"
                      scrollable
                      :disabled="isView"
                      :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="error" @click="startDatePicker = false">{{ $t('cancel') }}</v-btn>
                      <v-btn
                        text
                        color="success"
                        @click="$refs.startDate.save(startDate);editEndDate()"
                      >{{ $t('ok') }}</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="4" class="pt-0">
                  <v-menu
                    ref="endDate"
                    v-model="endDatePicker"
                    :close-on-content-click="false"
                    :return-value.sync="endDate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    :disabled="isView"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="isView"
                        v-model="endDate"
                        :label="$t('end_date')"
                        readonly
                        prepend-inner-icon="mdi-calendar"
                        solo
                        flat
                        v-bind="attrs"
                        rounded
                        background-color="grey lighten-4"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="th"
                      v-model="endDate"
                      no-title
                      scrollable
                      :header-date-format="$helper.headerDateFormat"
                      :year-format="$helper.yearFormat"
                      :disabled="isView"
                      :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="error" @click="endDatePicker = false">{{ $t('cancel') }}</v-btn>
                      <v-btn
                        text
                        color="success"
                        @click="$refs.endDate.save(endDate);editEndDate()"
                      >{{ $t('ok') }}</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="4" class="pt-0">
                  <v-currency-field
                    :rules="[rules.loanMin]"
                    :disabled="isView"
                    v-model="suspendDays"
                    @input="editSuspendDays"
                    :label="$t('duration_day')"
                    outlined
                    rounded
                    dense
                    background-color="grey lighten-4"
                    :messages="dayMonthYearText()"
                    :isDisabledDecimal="true"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <h3 class="mb-2 font-normal">{{ $t('operation_date') }}</h3>
              <v-menu
                ref="issueDate"
                v-model="issueDatePicker"
                :close-on-content-click="false"
                :return-value.sync="form.issueDate"
                transition="scale-transition"
                offset-y
                min-width="auto"
                :disabled="isView"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :disabled="isView"
                    v-model="form.issueDate"
                    :label="$t('area.event_date')"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    solo
                    flat
                    v-bind="attrs"
                    rounded
                    background-color="grey lighten-4"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  locale="th"
                  v-model="form.issueDate"
                  no-title
                  :header-date-format="$helper.headerDateFormat"
                  :year-format="$helper.yearFormat"
                  scrollable
                  :disabled="isView"
                  :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="error" @click="issueDatePicker = false">{{ $t('cancel') }}</v-btn>
                  <v-btn text color="success" @click="$refs.issueDate.save(form.issueDate)">{{ $t('ok') }}</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" v-if="isView">
              <div class="flex justify-between">
                <h3 class="mb-2 font-normal">{{ $t('customer.document_set_list') }}</h3>
                <v-btn
                  color="info"
                  small
                  elevation="0"
                  @click="contractDocumentDialog($event, false)"
                  :disabled="!getContract.isActive || isLoadContractDocument"
                >
                  <v-icon left>mdi-plus-box</v-icon>{{ $t('contract.add_contract_document') }}
                </v-btn>
              </div>
              <div class="py-5" v-if="!isLoadContractDocument">
                <card-contract-document
                  v-for="(doc, index) of getContractDocuments"
                  :key="`doc_${index}`"
                  :indexNumber="`${index + 1}`"
                  :object="doc"
                  @onView="contractDocumentDialog(doc, true, true)"
                  @onUpdated="contractDocumentDialog(doc, true)"
                  @onRemove="contractDocumentRemoveDialog(doc)"
                ></card-contract-document>
                <card-contract-document v-if="getContractDocuments.length < 1" :isNull="true"></card-contract-document>
              </div>
              <div class="flex justify-center" v-else>
                <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
              </div>
            </v-col>
          </v-row>
          <!-- <v-checkbox
            v-if="event == 'create'"
            label="ส่งข้อมูลไปยัง Toll Booth"
            v-model="form.tollboothAPI"
          ></v-checkbox>-->
          <h3 class="mb-2 font-normal">{{ $t('appeal.detail_optional') }}</h3>
          <v-text-field
            :disabled="isView"
            :label="$t('project.nature_of_incident')"
            solo
            flat
            class="mb-2 border"
            textarea
            v-model="form.detail"
          ></v-text-field>
          <h3 class="mb-2 font-normal">{{ $t('appeal.penalty_detail_optional') }}</h3>
          <v-text-field
            :disabled="isView"
            :label="$t('project.offense_rule')"
            solo
            flat
            class="mb-2 border"
            textarea
            v-model="form.penaltyDetail"
          ></v-text-field>
          <h3 class="mb-2 font-normal">{{ $t('project.image_if_have') }}</h3>
          <v-file-input
            :disabled="isView || isUploading"
            :label="$t('upload.upload_image')"
            solo
            flat
            class="border px-2 mb-2"
            hide-details
            accept="image/*"
            @change="uploadImage"
            ref="fileupload"
          ></v-file-input>
          <v-row v-if="form.images && form.images.length" class="mt-2 mb-3">
            <template v-for="(file, index) in form.images">
              <v-col cols="6" :key="file.name">
                <v-card>
                  <v-img :src="file.url">
                    <v-app-bar flat color="rgba(0, 0, 0, 0)">
                      <v-spacer></v-spacer>
                      <v-btn
                        style="margin: -25px -15px 0 0"
                        class="bg-white"
                        color="error"
                        elevation="2"
                        icon
                        rounded
                        small
                        :disabled="isView"
                        @click="removeFile(index)"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-app-bar>
                  </v-img>
                </v-card>
              </v-col>
            </template>
          </v-row>
          <h3 class="mb-2 font-normal">{{ $t('detail') }} ({{ $t('optional') }})</h3>
          <v-text-field
            :disabled="isView"
            :label="$t('note')"
            solo
            flat
            class="mb-2 border"
            textarea
            v-model="form.note"
          ></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="mx-2 flex justify-space-between">
          <div>
            <div v-if="form.type == 'other' && !form.otherType && !isView" class="text-red-800">
              <b class="text-red-400 mr-1">*</b>{{ $t('suspend.input_title_business_suspend') }}
            </div>
            <div v-if="form.isSuspend && suspendDays <= 0 && !isView" class="text-red-800">
              <b class="text-red-400 mr-1">*</b>{{ $t('suspend.set_suspend_time') }}
            </div>
          </div>
          <div>
            <v-btn color="error" elevation="0" @click="closeForm" class="mx-5">
              <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
            </v-btn>
            <v-btn
              color="success"
              elevation="0"
              :disabled="isView || (form.type == 'other'&&!form.otherType) || (form.isSuspend && suspendDays <= 0)"
              @click="saveForm"
            >
              <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <contract-document
      v-model="isContractDocument"
      :projectId="projectId"
      :marketId="marketId"
      :contract-id="getContractId || null"
      :isUpdate="isContractDocumentUpdate"
      :object-id="isContractDocumentId"
      :isDisable="isContractDocumentDisable"
      :contractSuspend="obj"
    ></contract-document>
    <confirm-dialog-component
      v-model="isConfirmContractDocumentRemove"
      @onOk="contractDocumentRemove"
      :title="$t('validate.you_want_to_delete_this_document_set')"
      type="error"
    ></confirm-dialog-component>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ContractDocument from "./ContractDocument.vue";
import CardContractDocument from "./CardContractDocument.vue";
import ConfirmDialogComponent from "./ConfirmDialog.component.vue";
import { FileUpload } from "../classes";
export default {
  name: "Suspend",
  components: {
    ContractDocument,
    CardContractDocument,
    ConfirmDialogComponent
  },
  computed: {
    ...mapGetters({
      getContract: "contract/getContract",
      getContractId: "contract/getContractId",
      getContractDocuments: "contractDocument/getContractDocuments"
    }),
    sespend: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  watch: {
    sespend(value) {
      if (value) {
        if (this.isView) this.loadContractDocuments();
        if (this.event == "edit" || this.isView) {
          const newObj = JSON.parse(JSON.stringify(this.obj));
          newObj.startDate = this.$moment(newObj.startDate?.iso).format(
            "YYYY-MM-DD"
          );
          newObj.endDate = this.$moment(newObj.endDate?.iso).format(
            "YYYY-MM-DD"
          );
          newObj.issueDate = this.$moment(newObj.issueDate?.iso).format(
            "YYYY-MM-DD"
          );
          this.form = newObj;
        } else {
          this.form = {
            id: "",
            // tollboothAPI: true,
            isSuspend: true,
            type: "temporary",
            otherType: "",
            issueDate: this.$moment().format("YYYY-MM-DD"),
            startDate: this.$moment().format("YYYY-MM-DD"),
            endDate: this.$moment().format("YYYY-MM-DD"),
            note: "",
            penaltyDetail: "",
            detail: "",
            images: []
          };
        }
        this.startDate = this.form.startDate;
        this.endDate = this.form.endDate;
        this.suspendDays = 0;
        this.editEndDate();
      }
    }
  },
  data() {
    return {
      marketId: this.$route.params.marketId,
      projectId: this.$route.params.projectId,
      rules: {
        required: value => !!value || this.$t('validate.please_input_data'),
        loanMin: value => parseFloat(value) > 0 || this.$t('validate.time_must_be_greater_than_zero')
      },
      suspendTypeLabel: [],
      form: {
        id: "",
        // tollboothAPI: true,
        isSuspend: true,
        type: "temporary",
        otherType: "",
        issueDate: this.$moment().format("YYYY-MM-DD"),
        startDate: this.$moment().format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
        note: "",
        penaltyDetail: "",
        detail: "",
        images: []
      },
      startDate: this.$moment().format("YYYY-MM-DD"),
      endDate: this.$moment().format("YYYY-MM-DD"),
      suspendDays: 0,
      issueDatePicker: false,
      startDatePicker: false,
      endDatePicker: false,
      isContractDocument: false,
      isContractDocumentUpdate: false,
      isContractDocumentId: "",
      isContractDocumentDisable: false,
      isConfirmContractDocumentRemove: false,
      isLoadContractDocument: false,
      isUploading: false
    };
  },
  props: {
    value: Boolean,
    isView: Boolean,
    obj: Object,
    event: String,
    onFirst: Boolean
  },
  created() {
    this.suspendTypeLabel = [
        {
          value: "temporary",
          label: this.$t('suspend.type.temporary')
        },
        {
          value: "leave",
          label: this.$t('suspend.type.leave')
        },
        {
          value: "late",
          label: this.$t('suspend.type.late')
        },
        {
          value: "warn_1",
          label: this.$t('suspend.type.warn_1')
        },
        {
          value: "warn_2",
          label: this.$t('suspend.type.warn_2')
        },
        {
          value: "warn_3",
          label: this.$t('suspend.type.warn_3')
        },
        {
          value: "other",
          label: this.$t('suspend.type.other')
        }
    ];
  },
  methods: {
    async loadContractDocuments() {
      if (this.getContractId) {
        this.isLoadContractDocument = true;
        await this.$store.dispatch("contractDocument/getContractDocuments", {
          contractId: this.getContractId
        });
        this.isLoadContractDocument = false;
      }
    },
    saveForm() {
      this.form.startDate = this.startDate;
      this.form.endDate = this.endDate;
      const newCopy = JSON.parse(JSON.stringify(this.form));
      if (this.event == "edit") {
        this.$emit("onSaveEdit", newCopy);
      } else if (this.event == "create") {
        this.$emit("onSave", newCopy);
      }
      this.sespend = false;
    },
    closeForm() {
      this.$emit("onClose", this.form);
      this.sespend = false;
    },
    diffDays() {
      let days = 0;
      let minutes = 0;
      if (this.startDate && this.endDate) {
        minutes =
          this.$moment(this.endDate, "YYYY-MM-DD").diff(
            this.$moment(this.startDate, "YYYY-MM-DD"),
            "minutes"
          ) || 0;
        days = Math.ceil(minutes / (24 * 60)) + 1;
      }
      return days;
    },
    editSuspendDays(value) {
      let days = parseFloat(value);
      if (days && days > -1) {
        days--;
        let momentStartDate = this.$moment(this.startDate, "YYYY-MM-DD");
        momentStartDate.add(days, "days");
        this.endDate = momentStartDate.format("YYYY-MM-DD");
      }
    },
    editEndDate() {
      this.suspendDays = this.diffDays();
    },
    dayMonthYearText() {
      let days = 0;
      let months = 0;
      let years = 0;
      let text = "";
      if (this.startDate && this.endDate) {
        let a = this.$moment(this.endDate, "YYYY-MM-DD").endOf("day");
        let b = this.$moment(this.startDate, "YYYY-MM-DD").startOf("day");
        a.add(1, "days");
        years = a.diff(b, "year");
        b.add(years, "years");
        months = a.diff(b, "months");
        b.add(months, "months");
        days = a.diff(b, "days");
      }
      if (years) {
        text += `${years} ${this.$t('year')} `;
      }
      if (months) {
        text += `${months} ${this.$t('month')} `;
      }
      if (days) {
        text += `${days} ${this.$t('day')}`;
      }
      return text;
    },
    contractDocumentRemoveDialog(item) {
      this.isConfirmContractDocumentRemove = true;
      this.isContractDocumentId = item.objectId;
    },
    async contractDocumentRemove() {
      await this.$store.dispatch("contractDocument/removeContractDocument", {
        id: this.isContractDocumentId
      });
      if (this.getContractId) this.loadContractDocuments();
    },
    contractDocumentDialog(e, isUpdate = false, isDisable = false) {
      this.isContractDocumentUpdate = isUpdate || false;
      this.isContractDocumentDisable = isDisable || false;
      if (isUpdate) {
        this.isContractDocumentId = e.objectId;
      }
      this.isContractDocument = true;
    },
    async uploadImage(fileData) {
      if (fileData) {
        this.isUploading = true;
        try {
          let file = await FileUpload.upload(fileData);
          this.form.images.push(file);
          this.$refs.fileupload.reset();
          this.$refs.fileupload.blur();
          this.isUploading = false;
        } catch (err) {
          this.isUploading = false;
          this.$toast.show({
            content: this.$t('error'),
            color: "error"
          });
        }
      }
    },
    removeFile(index) {
      this.form.images.splice(index, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-suspend-form-in.v-card__text::v-deep {
  height: 600px;
  max-height: calc(90vh - 65px - 64px);
}
</style>
